import { render, staticRenderFns } from "./BrandDetail.vue?vue&type=template&id=6b301dc0&scoped=true&"
import script from "./BrandDetail.vue?vue&type=script&lang=js&"
export * from "./BrandDetail.vue?vue&type=script&lang=js&"
import style0 from "./BrandDetail.vue?vue&type=style&index=0&id=6b301dc0&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b301dc0",
  null
  
)

export default component.exports